export default __webpack_public_path__ + "images/ff5028127e8cefc922acbb856d0dde3b.jpg";